module.exports = __webpack_public_path__ + "static/media/downloadRightImage.e4c20b50.png";